import React from "react";
import { CloseOutlined } from "@ant-design/icons";

const LabelSelector = ({ labels, selectedLabels, onToggleLabel }) => {
  return (
    <div
      style={{
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "center",
        gap: "8px",
        padding: "8px",
      }}
    >
      {labels.map((label) => {
        const isSelected = selectedLabels.includes(label);
        return (
          <div
            key={label}
            onClick={() => onToggleLabel(label)}
            style={{
              display: "flex",
              alignItems: "center",
              padding: "6px 12px",
              borderRadius: "9999px",
              background: isSelected
                ? "linear-gradient(90deg, #93C5FD, #BFDBFE)" // light blue gradient
                : "#F3F4F6", // very light gray
              border: isSelected ? "none" : "1px solid #E5E7EB",
              color: isSelected ? "#1E3A8A" : "#374151",
              cursor: "pointer",
              transition: "all 0.2s ease-in-out",
              boxShadow: isSelected ? "0px 2px 4px rgba(0, 0, 0, 0.1)" : "none",
            }}
          >
            <span
              style={{
                marginRight: isSelected ? "6px" : "0px",
                fontWeight: isSelected ? 600 : 400,
                fontSize: "14px",
              }}
            >
              {label}
            </span>
            {isSelected && <CloseOutlined style={{ fontSize: "12px", opacity: 0.9 }} />}
          </div>
        );
      })}
    </div>
  );
};

export default LabelSelector;
